<template>
  <component :is="name" />
</template>

<script>
import House from "@/Components/UI/Icons/House.vue"
import Edit from "@/Components/UI/Icons/Edit.vue"
import Enviar from "@/Components/UI/Icons/Enviar.vue"
import Comentar from "@/Components/UI/Icons/Comentar.vue"
import ComentarPreenchido from "@/Components/UI/Icons/ComentarPreenchido.vue"
import Filter from "@/Components/UI/Icons/Filter.vue"
import Facebook from "@/Components/UI/Icons/Facebook.vue"
import Twitch from "@/Components/UI/Icons/Twitch.vue"
import Twitter from "@/Components/UI/Icons/Twitter.vue"
import Visualizar from "@/Components/UI/Icons/Visualizar.vue"
import Sucesso from "@/Components/UI/Icons/Sucesso.vue"
import Upload from "@/Components/UI/Icons/Upload.vue"
import Slider from "@/Components/UI/Icons/Slider.vue"
import ArrowRight from "@/Components/UI/Icons/ArrowRight.vue"
import ArrowWithoutCircle from "@/Components/UI/Icons/ArrowWithoutCircle.vue"
import Seta from "@/Components/UI/Icons/Seta.vue"
import SetaEsquerda from "@/Components/UI/Icons/SetaEsquerda.vue"
import SetaDireita from "@/Components/UI/Icons/SetaDireita.vue"
import Redimensionar from "@/Components/UI/Icons/Redimensionar.vue"
import Perfil from "@/Components/UI/Icons/Perfil.vue"
import Notificacao from "@/Components/UI/Icons/Notificacao.vue"
import MenuLogado from "@/Components/UI/Icons/MenuLogado.vue"
import Loader from "@/Components/UI/Icons/Loader.vue"
import LinkExterno from "@/Components/UI/Icons/LinkExterno.vue"
import Fechar from "@/Components/UI/Icons/Fechar.vue"
import Erro from "@/Components/UI/Icons/Erro.vue"
import Excluir from "@/Components/UI/Icons/Excluir.vue"
import Editar from "@/Components/UI/Icons/Editar.vue"
import Curtir from "@/Components/UI/Icons/Curtir.vue"
import CurtirPressionado from "@/Components/UI/Icons/CurtirPressionado.vue"
import ChevronP from "@/Components/UI/Icons/ChevronP.vue"
import ChevronM from "@/Components/UI/Icons/ChevronM.vue"
import ChatRetratil from "@/Components/UI/Icons/ChatRetratil.vue"
import Snapchat from "@/Components/UI/Icons/Snapchat.vue"
import Telegram from "@/Components/UI/Icons/Telegram.vue"
import Whatsapp from "@/Components/UI/Icons/Whatsapp.vue"
import Instagram from "@/Components/UI/Icons/Instagram.vue"
import Linkedin from "@/Components/UI/Icons/Linkedin.vue"
import Youtube from "@/Components/UI/Icons/Youtube.vue"
import TikTok from "@/Components/UI/Icons/Tiktok.vue"
import Baixar from "@/Components/UI/Icons/Baixar.vue"
import LogoFooter from "@/Components/UI/Icons/LogoFooter.vue"
import Pesquisar from "@/Components/UI/Icons/Pesquisar.vue"
import Camera from "@/Components/UI/Icons/Camera.vue"
import CameraUpload from "@/Components/UI/Icons/CameraUpload.vue"
import EstrelaHover from "@/Components/UI/Icons/EstrelaHover.vue"
import Expandir from "@/Components/UI/Icons/Expandir.vue"
import Galeria from "@/Components/UI/Icons/Galeria.vue"
import CheckMark from "@/Components/UI/Icons/CheckMark.vue"
import Exclamation from "@/Components/UI/Icons/Exclamation.vue"
import Minus from "@/Components/UI/Icons/Minus.vue"
import Plus from "@/Components/UI/Icons/Plus.vue"
import GalleryCard from "@/Components/UI/Icons/GalleryCard.vue"
import GalleryCardMiniature from "@/Components/UI/Icons/GalleryCardMiniature.vue"
import ChevronBack from "@/Components/UI/Icons/ChevronBack.vue"
import InformationCircle from "@/Components/UI/Icons/InformationCircle.vue"


export default {
  props: {
      name: String,
  },
  components: {
    Enviar,
    Comentar,
    ComentarPreenchido,
    Edit,
    Filter,
    Facebook,
    Twitch,
    Twitter,
    Visualizar,
    Sucesso,
    Upload,
    Slider,
    ArrowRight,
    ArrowWithoutCircle,
    Seta,
    SetaEsquerda,
    SetaDireita,
    Redimensionar,
    Perfil,
    Notificacao,
    MenuLogado,
    Loader,
    LinkExterno,
    Fechar,
    Erro,
    Editar,
    Excluir,
    Curtir,
    CurtirPressionado,
    ChevronP,
    ChevronM,
    ChatRetratil,
    Snapchat,
    Telegram,
    Whatsapp,
    Instagram,
    Linkedin,
    Youtube,
    TikTok,
    Baixar,
    LogoFooter,
    Pesquisar,
    Camera,
    CameraUpload,
    EstrelaHover,
    Expandir,
    Galeria,
    CheckMark,
    Exclamation,
    Minus,
    Plus,
    GalleryCard,
    GalleryCardMiniature,
    House,
    ChevronBack,
    InformationCircle,
  },
};
</script>
